import { JSX, useMemo } from 'react'

import { Flex } from 'core-components/library/flex'
import { Table } from 'core-components/library/list'
import { ModalDialog } from 'core-components/library/modalDialog'
import { IRenderCustomSettingsParams } from 'core-components/sitebuilder/layout/flexItem/models/IRenderCustomContent'
import { NewWidgetsButtons } from 'core-components/sitebuilder/layout/flexItem/NewWidgetsButtons'
import { IWidget } from 'core-components/sitebuilder/models/IWidget'
import { IWidgetsData } from 'core-components/sitebuilder/models/IWidgetData'
import { BaseCrud, Static } from 'core-components/types'

import { GroupFilter } from './configuratorList/GroupFilter'
import { WidgetTypeFilter } from './configuratorList/WidgetTypeFilter'

import styles from './ConfiguratorList.module.scss'

export interface IProps {
  widgets: IWidget[]
  open: boolean
  onUpdatePageWidgetsData: (widgetsData: IWidgetsData[]) => void
  onClose: () => void
  renderCustomSettingsWidget?: (data: IRenderCustomSettingsParams) => JSX.Element | null
}

export const WidgetsListConfiguratorList = ({
  widgets,
  open,
  onUpdatePageWidgetsData,
  onClose,
  renderCustomSettingsWidget,
}: IProps) => {
  const widgetSource = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(widgets),
      keyField: 'i',
    })
  }, [widgets])

  return (
    <ModalDialog
      size={'md'}
      show={open}
      onClose={onClose}
      title={'Select widget'}
      content={() => (
        <>
          <Flex className={styles.actions}>
            <NewWidgetsButtons
              renderCustomSettingsWidget={renderCustomSettingsWidget}
              getWidgetAfterSaving={(widget: IWidget) => {
                const widgetData = {
                  i: widget.i,
                  x: widget.x,
                  y: widget.y,
                  w: widget.w,
                  h: widget.h,
                  area: '0',
                  scale: 100,
                }
                onUpdatePageWidgetsData([widgetData])
              }}
            />
          </Flex>
          <Table<IWidget>
            header
            pagination
            className={styles.issueTable}
            onClick={(issueItem) => {
              const widgetData = {
                i: issueItem.i,
                x: issueItem.x,
                y: issueItem.y,
                w: issueItem.w,
                h: issueItem.h,
                area: '0',
                scale: 100,
              }
              onUpdatePageWidgetsData([widgetData])
            }}
            columns={[
              { priority: 0, title: 'Id', field: 'i' },
              { priority: 1, title: 'Title', field: 'title' },
              { priority: 2, title: 'Group', field: 'group', customFilter: GroupFilter },
              { priority: 3, title: 'Type', field: 'type', customFilter: WidgetTypeFilter },
            ]}
            source={widgetSource}
          />
        </>
      )}
    />
  )
}
